// src/services/api.js
import axios from "axios";

const API_URL =
  process.env.REACT_APP_API_URL || "https://rrhh.grupoolibru.com/api/";

// Crea instancia
export const api = axios.create({
  baseURL: API_URL,
  headers: { "Content-Type": "application/json" }
});

// Interceptor para inyectar token correctamente
api.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  // Asegura que siempre se mande JSON
  config.headers["Content-Type"] = "application/json;charset=utf-8";
  config.headers["Accept"] = "application/json";

  console.log("📡 axios request →", {
    url: config.baseURL + config.url,
    method: config.method,
    hasToken: !!token,
  });

  return config;
});


// Interceptor para 401
api.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err?.response?.status === 401) {
      localStorage.removeItem("token");
      localStorage.removeItem("rol");
      localStorage.removeItem("empleado_id");
      window.location.href = "/login";
    }
    return Promise.reject(err);
  }
);

// === Endpoints ===
export const auth = {
  login: (correo, password) => api.post("auth.php", { correo, password }),
  validate: () => api.get("validate_token.php")
};

export const empleados = {
  list: () => api.get("empleados.php"),
  create: (payload) => api.post("empleados.php", payload)
};

export const percepciones = {
  list: () => api.get("percepciones.php"),
  create: (payload) => api.post("percepciones.php", payload)
};

export const deducciones = {
  list: () => api.get("deducciones.php"),
  create: (payload) => api.post("deducciones.php", payload)
};
